export const validCharacterCheck = (input: string): boolean => {
  const test = /^[A-Za-z0-9.,!?&'\-_@ ]*$/;
  return test.test(input);
};

export const isEmptyName = (input: string): boolean => {
  return input.trim() === "";
};
